<div class="lpo-dialog-container invoice-template">
  <div class="lpo-header-actions no-print">
    <h2>Invoice Preview</h2>
    <div class="spacer"></div>

    <!-- Upload Buttons -->

    <!-- Invoice -->
    <button
      mat-stroked-button
      color="primary"
      (click)="openUploadDialog('invoice')"
      style="margin-right: 16px"
      *ngIf="canEditInvoice"
    >
      <mat-icon>{{
        uploadedInvoiceUrl ? "check_circle" : "upload_file"
      }}</mat-icon>
      {{ uploadedInvoiceUrl ? "Invoice Uploaded" : "Upload Invoice" }}
    </button>
    <button
      mat-button
      color="primary"
      *ngIf="isFinalized && uploadedInvoiceUrl"
      (click)="openUploadDialog('invoice')"
      style="margin-right: 16px"
    >
      <mat-icon>receipt</mat-icon> View Invoice
    </button>

    <button mat-button (click)="close()" style="margin-right: 8px">
      Close
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirmAndSend()"
      *ngIf="canEditInvoice"
    >
      <mat-icon>check_circle</mat-icon> Confirm & Send to Customer
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="downloadPdf()"
      *ngIf="isFinalized"
      style="margin-right: 8px"
      [disabled]="isPdfGenerating"
    >
      <mat-icon *ngIf="!isPdfGenerating">picture_as_pdf</mat-icon>
      <mat-spinner
        *ngIf="isPdfGenerating"
        diameter="20"
        style="display: inline-block; margin-right: 5px"
      ></mat-spinner>
      {{ isPdfGenerating ? "Generating..." : "Download PDF" }}
    </button>
  </div>

  <div class="lpo-scroll-area">
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Pricing Adjustments (Vendor Only & Not Finalized) -->
    <div
      *ngIf="canEditInvoice && !uploadedInvoiceUrl && !isLoading"
      class="pricing-adjustments no-print"
    >
      <h3><mat-icon>payments</mat-icon> Pricing Adjustments</h3>
      <div class="adj-row">
        <mat-form-field appearance="outline">
          <mat-label>Transport Cost (AED)</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="deliveryCharge"
            placeholder="0.00"
            min="0"
          />
          <mat-icon matPrefix>local_shipping</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Discount (AED)</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="discount"
            placeholder="0.00"
            min="0"
          />
          <mat-icon matPrefix>sell</mat-icon>
        </mat-form-field>
        
        <div class="final-preview">
          <span>Grand Total:</span>
          <strong>AED {{ getFinalTotal() | number: '1.2-2' }}</strong>
        </div>
      </div>
    </div>

    <!-- CASE 1: UPLOADED INVOICE DOCUMENT (Single Paper) -->
    <div class="lpo-paper" *ngIf="!isLoading && uploadedInvoiceUrl">
      <div class="uploaded-doc-container">
        <div
          *ngIf="isImage(uploadedInvoiceUrl)"
          class="image-preview"
          style="text-align: center"
        >
          <h3 style="margin-bottom: 20px; color: #1d4ed8">
            Uploaded Invoice Document
          </h3>
          <img
            [src]="uploadedInvoiceUrl"
            alt="Uploaded Invoice"
            style="max-width: 100%; border-radius: 4px"
          />
          <div style="margin-top: 20px" class="no-print">
            <a
              [href]="uploadedInvoiceUrl"
              target="_blank"
              mat-raised-button
              color="primary"
            >
              <mat-icon>open_in_new</mat-icon> View Full Resolution
            </a>
          </div>
        </div>

        <div
          *ngIf="!isImage(uploadedInvoiceUrl)"
          class="pdf-preview"
          style="text-align: center; padding: 40px"
        >
          <mat-icon
            style="font-size: 64px; height: 64px; width: 64px; color: #ef4444"
            >picture_as_pdf</mat-icon
          >
          <h2 style="margin-top: 20px">PDF Invoice Uploaded</h2>
          <p style="color: #6b7280; margin-bottom: 30px">
            A physical invoice document has been uploaded for this booking.
          </p>
          <a
            [href]="uploadedInvoiceUrl"
            target="_blank"
            mat-raised-button
            color="warn"
            style="padding: 10px 30px; font-size: 16px"
          >
            <mat-icon>download</mat-icon> View / Download Invoice
          </a>

          <!-- Embedding PDF -->
          <div
            style="margin-top: 40px; height: 800px; border: 1px solid #e5e7eb"
            class="no-print"
          >
            <iframe
              [src]="uploadedInvoiceUrl | safeUrl"
              width="100%"
              height="100%"
              style="border: none"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- CASE 2: GENERATED INVOICE (Multi-Page Paper) -->
    <ng-container *ngIf="!isLoading && !uploadedInvoiceUrl">
      <!-- PAGE 1: DASHBOARD / SUMMARY -->
      <div #pdfPage1 class="lpo-paper pdf-page-container">
        <!-- Header -->
        <!-- Header -->
        <div class="receipt-header">
          <div class="brand-info">
            <!-- Vendor Logo -->
            <div
              class="company-logo"
              *ngIf="vendorLogoBase64 || vendorBranding.logo"
            >
              <img
                [src]="vendorLogoBase64 || vendorBranding.logo"
                alt="Vendor Logo"
              />
            </div>
            <div class="v-info">
              <h1>{{ vendorBranding.name }}</h1>
              <p>{{ vendorBranding.address || "Address not available" }}</p>
              <p *ngIf="vendorBranding.phone">
                Phno: {{ vendorBranding.phone }}
              </p>
              <p>Email: {{ vendorBranding.email || "N/A" }}</p>
            </div>
          </div>
        </div>

        <!-- Centered Heading -->
        <div class="receipt-center-title">
          <h2>TAX INVOICE</h2>
        </div>

        <!-- Addresses and Details -->
        <div class="receipt-body">
          <!-- FROM (Vendor) -->
          <div class="section-box">
            <h3>From (Vendor)</h3>
            <p>
              <strong>{{ vendorBranding.name }}</strong>
            </p>
            <p>{{ vendorBranding.address || "Address not available" }}</p>
          </div>

          <!-- Invoice Ref details (Aligned Right like LPO PO ref) -->
          <div class="section-box text-right">
            <h3>Invoice Details</h3>
            <p class="ref-no">Invoice #: {{ invoiceNumber }}</p>
            <p class="date">Date: {{ today | date: "dd MMM yyyy" }}</p>
            <p>
              Booking ID: #{{ data.bookingId.substring(0, 8).toUpperCase() }}
            </p>
            <div *ngIf="isFinalized" class="status-badge-inline">FINALIZED</div>
          </div>
        </div>

        <div class="receipt-body">
          <!-- CUSTOMER (Client) -->
          <div class="section-box">
            <h3>Bill To (Customer)</h3>
            <p>
              <strong>{{ customerBranding.name }}</strong>
            </p>
            <p>{{ customerBranding.address || "Address not available" }}</p>
          </div>
          <div class="section-box"></div>
          <!-- Spacer to match layout -->
        </div>

        <!-- Vehicle Summary (Global) -->
        <div class="vehicle-summary-card">
          <h3>Equipment Detailed Information</h3>
          <div class="summary-grid">
            <div class="summary-item">
              <span class="label">Equipment Name</span>
              <span class="value">{{
                data.booking.equipment?.name || "N/A"
              }}</span>
            </div>
            <div class="summary-item">
              <span class="label">Brand & Model</span>
              <span class="value"
                >{{ data.booking.equipment?.brand }}
                {{ data.booking.equipment?.model }}</span
              >
            </div>
            <div class="summary-item">
              <span class="label">Plate Number</span>
              <span class="value">{{
                data.booking.equipment?.plate_number || "N/A"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Payment Summary (Full Width) -->
        <div class="payment-summary-section">
          <h3>Payment Summary</h3>

          <div class="summary-row" *ngIf="getTotalHours() > 0">
            <span>Total Billable Hours:</span>
            <strong>{{ getTotalHours() | number: "1.2-2" }} hrs</strong>
          </div>

          <div class="summary-row">
            <span>Subtotal:</span>
            <span>AED {{ getBalanceDue() | number: "1.2-2" }}</span>
          </div>

          <div *ngIf="deliveryCharge > 0" class="summary-row">
            <span>Transport Cost:</span>
            <span>AED {{ deliveryCharge | number: "1.2-2" }}</span>
          </div>

          <div *ngIf="discount > 0" class="summary-row" style="color: #ef4444">
            <span>Discount:</span>
            <span>-AED {{ discount | number: "1.2-2" }}</span>
          </div>

          <div class="summary-row">
            <span>Tax (0%):</span>
            <span>AED 0.00</span>
          </div>

          <div class="total-row">
            <strong>Grand Total:</strong>
            <strong>AED {{ getFinalTotal() | number: "1.2-2" }}</strong>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="notes">
            <h3>Notes & Terms</h3>
            <p>1. Please pay within 15 days of receiving this invoice.</p>
            <p>2. Payment can be made via Bank Transfer or Portal.</p>
          </div>
        </div>

        <!-- Signature Section redesigned to match LPO -->
        <div
          class="signature-section"
          *ngIf="signatureBase64 || signatureUrl || canEditInvoice"
          style="display: flex; gap: 40px"
        >
          <!-- Symmetrical Column (Like LPO) -->
          <!-- <div class="sig-block" style="flex: 1">
            <div class="sig-box no-print" *ngIf="!isFinalized">
              <div class="line"></div>
              <p>Customer Acknowledgement</p>
            </div>
          </div> -->

          <div class="sig-block" style="flex: 1">
            <!-- Signature Image & Info -->
            <ng-container *ngIf="signatureBase64 || signatureUrl; else noSig">
              <div class="signature-display">
                <img [src]="signatureBase64 || signatureUrl" alt="Vendor Signature" />
                <button
                  mat-icon-button
                  color="warn"
                  (click)="signatureUrl = ''; signatureBase64 = null"
                  class="no-print delete-sig-btn"
                  *ngIf="canEditInvoice"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <div class="sig-box">
                <div class="line"></div>
                <p>Vendor Authorized Signature</p>
              </div>
            </ng-container>

            <!-- Edit mode (No signature) -->
            <ng-template #noSig>
              <div
                class="signature-controls no-print"
                *ngIf="canEditInvoice; else blankSig"
              >
                <mat-tab-group animationDuration="0ms">
                  <mat-tab label="Upload Image">
                    <div class="upload-tab">
                      <input
                        type="file"
                        #invSigInput
                        hidden
                        (change)="onSigSelected($event)"
                        accept="image/*"
                      />
                      <button
                        mat-stroked-button
                        color="primary"
                        (click)="invSigInput.click()"
                      >
                        <mat-icon>upload</mat-icon> Upload Signature
                      </button>
                    </div>
                  </mat-tab>
                  <mat-tab label="Draw Signature">
                    <div class="draw-tab">
                      <div class="canvas-wrapper">
                        <canvas
                          #sigCanvas
                          width="300"
                          height="120"
                          (mousedown)="startDrawing($event)"
                          (mousemove)="draw($event)"
                          (mouseup)="stopDrawing()"
                          (mouseleave)="stopDrawing()"
                        >
                        </canvas>
                      </div>
                      <div class="canvas-actions">
                        <button mat-button color="warn" (click)="clearCanvas()">
                          Clear
                        </button>
                        <button
                          mat-raised-button
                          color="primary"
                          (click)="saveCanvasSignature()"
                        >
                          Use Signature
                        </button>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>
              <ng-template #blankSig>
                <div class="sig-box empty-sig">
                  <div class="line"></div>
                  <p>Vendor Authorized Signature</p>
                </div>
              </ng-template>
            </ng-template>
          </div>

          <!-- Finalized indicator -->
          <div
            *ngIf="isFinalized"
            class="completion-signature-prompt pending"
            style="margin-top: 15px"
          >
            <mat-icon color="primary">verified</mat-icon>
            <p>
              This invoice has been
              <strong>digitally signed and finalized</strong> on
              {{ data.booking.invoicedAt?.toDate() | date: "medium" }}.
            </p>
          </div>
        </div>
      </div>

      <!-- PAGE 2 removed per user request -->
    </ng-container>
  </div>
</div>
